<template>
    <div>
        <div class="defaultAlarmConfiguration-title">{{ $t('configuration_management.default_alarm_config.defaultAlarmConfig') }}</div>
        <div class="defaultAlarmConfiguration-top">
            <default-alarm-configuration-search></default-alarm-configuration-search>
        </div>
        <table-default-alarm-configuration></table-default-alarm-configuration>
    </div>
</template>

<script>
    import TableDefaultAlarmConfiguration from '../default_alarm_configuration/TableDefaultAlarmConfiguration'
    import DefaultAlarmConfigurationSearch from '../default_alarm_configuration/DefaultAlarmConfigurationSearch'

    export default {
        name: 'DefaultAlarmConfiguration',
        components: {
            TableDefaultAlarmConfiguration,
            DefaultAlarmConfigurationSearch
        }
    }
</script>

<style scoped>
    .defaultAlarmConfiguration-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .defaultAlarmConfiguration-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/default_alarm_configuration/DefaultAlarmConfiguration.vue